export default "__VITE_ASSET__BQd5DWof__"